import React, { useEffect, useState } from 'react'
import { Block, Calculator, Delete, Eye, Pencil, Search } from '../../common/Icons'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toaster } from '../../apis/commonFunctions'
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../apis/functions'
import APIS from '../../apis/routes'
import NoDataRow from '../../common/NoDataRow'
import LoadingRow from '../../common/LoadingRow'
import Button from '../../common/Button'
import Switch from "react-switch";
import ConfirmationPopup from '../../common/popups/ConfirmationPopup'
import Pagination from '../../common/Pagination'
import Search_input from '../../common/Search_input'
import moment from 'moment/moment'
import AddPrompt from '../../common/popups/AddPrompt'
import MyRow from './MyRow'



export default function Prompt() {
    const [all, setAll] = useState([]);
    const router = useNavigate()
    const [skip, setSkip] = useState(0)
    const [quesiton_type, setQueston] = useState(null)
    const [limit, setLimit] = useState(8);
    const [mainid, setMainId] = useState("");
    const [total, setTotal] = useState(0)
    const [params] = useSearchParams();
    // console.log(Array.from(params.entries())," thishsishihsih")
    const search = params.get('search')

    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getRequest(`${APIS.GET_PROMPTS}?search=${search ?? ""}&skip=${skip}&limit=${limit}`);
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false)
            } else {
                setAll(result.data.data)
                // setTotal(result.data.total_count)

            }
        } catch (err) {
            toaster(err.message, false);
        }
    }

    function handlePageClick({ selected }) {
        setSkip(selected * limit)
    }

    function onFetch() {
        fetchData();
    }


    useEffect(() => {
        fetchData();
    }, [search, skip]);

    const addPrompt = async (obj) => {
        try {
            setLoading(true);
            const result = await postRequest(APIS.CREATE_PROMPT, obj);
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false)
            } else {
                toaster(result.data.message, true);
                // setTotal(result.data.total_count)
                onFetch()

            }
        } catch (err) {
            toaster(err.message, false);
        }
    }

    return (
        <>
            <div className="top_bar row align-items-center mt-3">
                <div className="col-lg-6">
                    <div className="pagetitle">
                        Prompt Management <br />
                    </div>
                </div>
                <div className="col-lg-6 text-end">
                    <Button text="Add Prompt" className="btn btn-success" data-bs-toggle="modal" data-bs-target="#modaladd_prompt" />
                    {/* <Search_input placeholder={'Search here'} search={search} handleSearch={(e) => router('?search=' + (e.nativeEvent.data === " " ? search + "+" : e.target.value))} icon={<Search />} className='search_input' /> */}
                </div>
            </div>
            <div className="row mt-5">
                <div className="table-responsive">
                    <table className='table table-lg'>
                        <thead className='table-light'>
                            <tr colSpan="4">
                                <th>S.No</th>
                                <th>Prompt</th>
                                <th>Premium</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {all.length > 0
                                &&
                                all.map((element, index) => (
                                    <MyRow onFetch={() => {
                                        fetchData();
                                    }} element={element} index={index} />
                                ))
                            }
                            {!loading && all.length <= 0 && <NoDataRow />}

                            {loading && <LoadingRow />}
                            {total > limit && <tr className='text-center'><td colSpan={20}><Pagination handlePageClick={handlePageClick} totalCount={total} limit={limit} /></td></tr>}

                        </tbody>
                    </table>
                </div>
            </div>
            <AddPrompt onFetch={() => {
                fetchData()
            }} onYes={(obj) => {
                addPrompt(obj);
            }} question_type={1} id="add_prompt" message={"Add Prompt"} placeholder={'Enter the Prompt'}/>
        </>
    )
}